var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Alert, Button, Col, DotsLoader, ExpandableSection, Form, Icon, Loader, Row, SubmitButton, UtilitiesContext, } from "@brushfire/ui";
import { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import FormikContextListener from "../../Helpers/FormikContextListener";
import WidgetFieldset from "../../Helpers/WidgetFieldset";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import Constants from "../../../data/constants";
import { AppFormContext } from "../../../App";
import { getProfile, putProfile } from "../../../data/api";
import { FieldType, OAuthContext } from "@brushfire/types";
import { LOCAL_STORAGE_KEYS, setLocal } from "../../../data/localStorageHelpers";
import { handleErrors } from "../../../data/helpers";
import BrushfireField from "@brushfire/ui/dist/Elements/Form/BrushfireField";
import { IntlProvider, useIntl } from "react-intl";
import { isPossiblePhoneNumber } from "react-phone-number-input/input";
var useTypedSelector = useSelector;
var IntlConsumer = function (_a) {
    var children = _a.children;
    var intl = useIntl();
    return children(intl);
};
var Profile = function (_a) {
    var path = _a.path;
    var _b = __read(useState(), 2), account = _b[0], setAccount = _b[1];
    var _c = __read(useState(), 2), initialValues = _c[0], setInitialValues = _c[1];
    var _d = __read(useState(false), 2), showSuccess = _d[0], setShowSuccess = _d[1];
    var _e = __read(useState(null), 2), paramMessage = _e[0], setParamMessage = _e[1];
    var dispatch = useDispatch();
    var formikContext = useContext(AppFormContext).formikContext;
    var customerAccount = useTypedSelector(function (store) { return store.accounts; }).customerAccount;
    var search = useLocation().search;
    var errorParam = new URLSearchParams(search).get("error");
    var successParam = new URLSearchParams(search).get("success");
    useEffect(function () {
        setParamMessage({
            message: errorParam || successParam,
            type: errorParam ? "danger" : "success",
        });
    }, [errorParam, successParam]);
    useEffect(function () {
        getProfile()
            .then(function (_a) {
            var data = _a.data;
            setAccount(data);
            var newVals = Object.assign({}, data);
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            //@ts-ignore
            delete newVals.services;
            setInitialValues(__assign(__assign({}, newVals), { currentPassword: "", newPassword: "", confirmPassword: "" }));
        })
            .catch(function (err) {
            handleErrors(err, dispatch, formikContext, undefined, true);
        });
    }, []);
    var kiosk = useTypedSelector(function (store) { return store.utilities.kiosk; });
    var localization = useTypedSelector(function (store) { return store.utilities.localization; });
    var profileSchema = Yup.object().shape({
        firstName: Yup.string()
            .typeError("First Name is required")
            .required("First Name is required"),
        lastName: Yup.string()
            .typeError("Last Name is required")
            .required("Last Name is required"),
        email: Yup.string()
            .typeError("Email is required")
            .email("Email is invalid")
            .required("Email is required"),
        phone: Yup.string()
            .nullable()
            .test("valid", "Phone number is invalid", function (val) { return (val ? isPossiblePhoneNumber(val) : true); }),
        street1: Yup.string()
            .typeError("Address is required")
            .required("Address is required"),
        region: Yup.string()
            .typeError("Region is required")
            .required("Region is required"),
        city: Yup.string()
            .typeError("City is required")
            .required("City is required"),
        postalCode: Yup.string()
            .typeError("Postal Code is required")
            .required("Postal Code is required"),
        currentPassword: Yup.string()
            .nullable()
            .min(8)
            .max(500),
        newPassword: Yup.string()
            .nullable()
            .min(8)
            .max(500),
        confirmPassword: Yup.string()
            .nullable()
            .min(8)
            .max(500),
    });
    var submitProfile = function (values, formikHelpers, setGlobalError) {
        if (!(kiosk === null || kiosk === void 0 ? void 0 : kiosk.enabled)) {
            setLocal(LOCAL_STORAGE_KEYS.EMAIL, values.email);
        }
        putProfile(values)
            .then(function (_a) {
            var data = _a.data;
            formikHelpers.setSubmitting(false);
            //setLookupCreated(true);
            setShowSuccess(true);
            setTimeout(function () {
                setShowSuccess(false);
            }, 10000);
        })
            .catch(function (err) {
            handleErrors(err, dispatch, formikContext, setGlobalError);
        })
            .finally(function () {
            formikHelpers.setSubmitting(false);
        });
    };
    if (!initialValues || !account) {
        return (_jsx(Loader, { customLoadingIcon: _jsx(DotsLoader, { containerClasses: "global-loader-container" }), classes: "global-loader" }));
    }
    var addressField = {
        id: "",
        label: "Address",
        type: FieldType[FieldType.Address],
        value: "",
        validationExpression: "",
        isRequired: true,
        notes: "",
        hasError: false,
        errorMessage: "",
        isDisabled: false,
        isSensitive: false,
        isIntegration: false,
        isAdmin: false,
        specialFieldId: "",
        specialFieldLabel: "",
        parentOptionId: "",
        parentFieldId: null,
        formObjectId: null,
        options: [],
        childFields: [
            {
                id: "street1",
                label: "Street 1",
                value: "",
                displayOrder: 0,
                specialFieldLabel: "Street1",
            },
            {
                id: "street2",
                label: "Street 2",
                value: "",
                displayOrder: 1,
                specialFieldLabel: "Street2",
            },
            {
                id: "city",
                label: "City",
                value: "",
                displayOrder: 2,
                specialFieldLabel: "City",
            },
            {
                id: "region",
                label: "Region",
                value: "",
                displayOrder: 3,
                specialFieldLabel: "Region",
            },
            {
                id: "postalCode",
                label: "Postal Code",
                value: "",
                displayOrder: 4,
                specialFieldLabel: "PostalCode",
            },
            {
                id: "country",
                label: "Country",
                value: "",
                displayOrder: 5,
                specialFieldLabel: "Country",
            },
        ],
        remoteUrl: "",
        parentOptionIsSelected: false,
        hasRelevantOutput: false,
        confirm: false,
    };
    //const providerData: { label: string; value: string | null }[] = ;
    var avatarData = [
        {
            label: "Gravatar (Email)",
            value: null,
        },
    ];
    account.services.forEach(function (service) {
        avatarData.push({
            label: service,
            value: service,
        });
    });
    return (_jsx(_Fragment, { children: _jsx(UtilitiesContext.Provider, __assign({ value: { localization: localization } }, { children: _jsxs(IntlProvider, __assign({ locale: "en-US" }, { children: [_jsx(ExpandableSection, __assign({ expand: showSuccess }, { children: _jsx(Alert, __assign({ purpose: "success" }, { children: "Your account was updated!" })) })), _jsx(ExpandableSection, __assign({ expand: !!paramMessage }, { children: !!paramMessage && _jsx(Alert, __assign({ purpose: paramMessage === null || paramMessage === void 0 ? void 0 : paramMessage.type }, { children: paramMessage === null || paramMessage === void 0 ? void 0 : paramMessage.message })) })), _jsx(Form, __assign({ initialValues: initialValues, validationSchema: profileSchema, onSubmit: submitProfile, autoComplete: (kiosk === null || kiosk === void 0 ? void 0 : kiosk.enabled) ? "new-off" : "on", useUnsavedPrompt: false }, { children: function (_a) {
                            var formikContext = _a.formikContext;
                            return (_jsx(_Fragment, { children: _jsxs(WidgetFieldset, { children: [_jsxs("div", __assign({ className: "pos-relative m-bottom-well" }, { children: [_jsx(FormikContextListener, { currentPath: path, path: "".concat(Constants.Routes.profile), formikContext: formikContext, active: true, initialValues: initialValues, focusDelay: 500 }), _jsxs("div", __assign({ className: "d-flex" }, { children: [_jsx("div", { children: (customerAccount === null || customerAccount === void 0 ? void 0 : customerAccount.avatarUrl) && (_jsx("img", { className: "avatar profile-avatar m-right", style: { width: "32px", height: "32px" }, src: customerAccount.avatarUrl })) }), _jsxs("div", __assign({ className: "flex-1" }, { children: [_jsx("h3", __assign({ className: "display tt-uppercase" }, { children: "Account Details" })), (account === null || account === void 0 ? void 0 : account.email) && (_jsx("div", { children: _jsxs("p", { children: [_jsxs("span", __assign({ className: "tt-uppercase" }, { children: [account === null || account === void 0 ? void 0 : account.firstName, " ", account === null || account === void 0 ? void 0 : account.lastName, " (", account === null || account === void 0 ? void 0 : account.email, ")"] })), " ", _jsx("a", __assign({ href: "https://".concat(process.env.REACT_APP_DOMAIN, "/signout?returnUrl=/my"), className: "small" }, { children: "Not you?" })), _jsx("a", __assign({ href: "https://".concat(process.env.REACT_APP_DOMAIN, "/signout?returnUrl=/my"), className: "small f-right m-left" }, { children: "Sign Out" })), _jsx("span", __assign({ className: "f-right small" }, { children: " | " })), _jsx("a", __assign({ href: "/my", className: "small f-right m-right" }, { children: "My Events" }))] }) }))] }))] })), _jsx(Form.Input.NameInput, { isRequired: true, isColumn: false }), _jsx(IntlConsumer, { children: function (intl) { return (_jsx(BrushfireField, { id: "".concat(addressField.id), name: "".concat(addressField.id), fieldItem: addressField, currency: "USD", autoComplete: !(kiosk === null || kiosk === void 0 ? void 0 : kiosk.enabled), compact: true, defaultCountry: "US", intl: intl })); } }), _jsxs(Row, { children: [_jsx(Col, __assign({ sm: 6 }, { children: _jsx(Form.Field, { label: "Email", id: "email", name: "email", type: "email", autoComplete: (kiosk === null || kiosk === void 0 ? void 0 : kiosk.enabled) ? "new-off" : undefined, placeholder: "name@domain.com" }) })), _jsx(Col, __assign({ sm: 6 }, { children: _jsx(Form.Field, { component: Form.Input.Phone, label: "Phone", id: "phone", name: "phone", autoComplete: !(kiosk === null || kiosk === void 0 ? void 0 : kiosk.enabled) }) }))] }), _jsx(Form.Field, { label: "Use profile picture from", component: Form.Input.Select, id: "avatarSource", name: "avatarSource", data: avatarData, autoComplete: "off" }), _jsx("h3", __assign({ className: "display tt-uppercase" }, { children: "Change Password" })), _jsx(Form.Field, { label: "Current Password", id: "currentPassword", name: "currentPassword", type: "password", autoComplete: (kiosk === null || kiosk === void 0 ? void 0 : kiosk.enabled) ? "new-off" : "password" }), _jsx(Form.Field, { label: "New Password", id: "newPassword", name: "newPassword", type: "password", autoComplete: (kiosk === null || kiosk === void 0 ? void 0 : kiosk.enabled) ? "new-off" : "password" }), _jsx(Form.Field, { label: "Confirm New Password", id: "confirmPassword", name: "confirmPassword", type: "password", autoComplete: "new-off" })] })), _jsx(SubmitButton, __assign({ component: Button, type: "submit", classes: "btn-block", purpose: "primary" }, { children: "Save Changes" }))] }) }));
                        } })), _jsxs(Row, __assign({ className: "m-top" }, { children: [_jsxs(Col, __assign({ sm: 4 }, { children: [_jsxs("a", __assign({ href: "https://".concat(process.env.REACT_APP_DOMAIN).concat(account.services.includes("Facebook")
                                            ? "/oauth/remove?service=Facebook"
                                            : "/oauth/Facebook?context=".concat(OAuthContext.Profile)), className: "btn btn-facebook btn-block std-loader" }, { children: [_jsx(Icon, { type: "brand", icon: "facebook-f", classes: "fa-fw" }), " ", account.services.includes("Facebook") ? "Remove" : "Connect"] })), " "] })), _jsxs(Col, __assign({ sm: 4 }, { children: [_jsxs("a", __assign({ href: "https://".concat(process.env.REACT_APP_DOMAIN).concat(account.services.includes("Google")
                                            ? "/oauth/remove?service=Google"
                                            : "/oauth/Google?context=".concat(OAuthContext.Profile)), className: "btn btn-google btn-block std-loader" }, { children: [_jsx(Icon, { type: "brand", icon: "google", classes: "fa-fw" }), " ", account.services.includes("Google") ? "Remove" : "Connect"] })), " "] })), _jsxs(Col, __assign({ sm: 4 }, { children: [_jsxs("a", __assign({ href: "https://".concat(process.env.REACT_APP_DOMAIN).concat(account.services.includes("Apple")
                                            ? "/oauth/remove?service=Apple"
                                            : "/oauth/Apple?context=".concat(OAuthContext.Profile)), className: "btn btn-apple btn-block std-loader" }, { children: [_jsx(Icon, { type: "brand", icon: "apple", classes: "fa-fw" }), " ", account.services.includes("Apple") ? "Remove" : "Connect"] })), " "] }))] }))] })) })) }));
};
export default Profile;
